<template>
    <div class="water-mark" ref="waterMark">
    </div>
</template>

<script type="text/javascript">
export default {
    // 不要忘记了 name 属性
    name: 'waterMark',
    methods: {
        getImage() {
            // const url = `//${location.host}/api-wm/image?r=0&g=0&b=0`;
            const url = `//${location.host}/api-wm/image/visible`;
            this.$refs.waterMark.style.backgroundImage = `url(${url})`;
        }
    },
    mounted() {
        this.getImage();
    }
};
</script>

<style scoped>
.water-mark {
    background-repeat: repeat;
    background-size: 350px auto;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    pointer-events: none;
}

</style>
